import { c as _c } from "react/compiler-runtime";
import { getEntitiesByFpIdBusinessOwnersOptions } from '@onefootprint/fetch-dashboard';
import type { Entity } from '@onefootprint/request-types/dashboard';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import useDocuments from '@/entity/hooks/use-documents';
import AddressFieldset from '../address-fieldset';
import CustomDataFields from '../custom-data-fields';
import DocumentFieldset from '../document-fieldset';
import Fieldset from '../fieldset';
import GridLayout, { type Section, SectionKeys } from '../grid-layout';
import useFieldsets from './hooks/use-fieldsets';
import BusinessOwners from './hooks/use-fieldsets/components/business-owners';
type BusinessVaultProps = {
  entity: Entity;
};
const BusinessVault = t0 => {
  const $ = _c(30);
  const {
    entity
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "vault"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("business-details", t1);
  const {
    basic,
    address,
    custom
  } = useFieldsets();
  let t2;
  if ($[1] !== entity.id) {
    t2 = getEntitiesByFpIdBusinessOwnersOptions({
      path: {
        fpId: entity.id
      }
    });
    $[1] = entity.id;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const bosQuery = useQuery(t2);
  const {
    data: documents
  } = useDocuments(entity.id);
  const hasDocuments = !!documents && documents.length > 0;
  let t3;
  if ($[3] !== bosQuery.data) {
    t3 = bosQuery.data?.some(_temp);
    $[3] = bosQuery.data;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const hasBos = !!t3;
  let t4;
  if ($[5] !== entity.data) {
    t4 = entity.data.some(_temp2);
    $[5] = entity.data;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const hasCustomData = t4;
  let t5;
  if ($[7] !== basic.fields || $[8] !== basic.title) {
    t5 = {
      key: SectionKeys.BASIC,
      content: <Fieldset fields={basic.fields} title={basic.title} />
    };
    $[7] = basic.fields;
    $[8] = basic.title;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== address.fields || $[11] !== address.title) {
    t6 = {
      key: SectionKeys.ADDRESS,
      content: <AddressFieldset fields={address.fields} title={address.title} />
    };
    $[10] = address.fields;
    $[11] = address.title;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== entity || $[14] !== hasBos || $[15] !== t) {
    t7 = hasBos && {
      key: SectionKeys.BUSINESS_OWNERS,
      content: <Fieldset fields={[]} title={t(_temp3)}><BusinessOwners entity={entity} /></Fieldset>
    };
    $[13] = entity;
    $[14] = hasBos;
    $[15] = t;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== custom || $[18] !== entity || $[19] !== hasCustomData) {
    t8 = hasCustomData && {
      key: SectionKeys.CUSTOM,
      content: <CustomDataFields entity={entity} title={custom.title} />
    };
    $[17] = custom;
    $[18] = entity;
    $[19] = hasCustomData;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== documents || $[22] !== hasDocuments) {
    t9 = hasDocuments && {
      key: SectionKeys.DOCUMENTS,
      content: <DocumentFieldset documents={documents} />
    };
    $[21] = documents;
    $[22] = hasDocuments;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t5 || $[25] !== t6 || $[26] !== t7 || $[27] !== t8 || $[28] !== t9) {
    const sections = [t5, t6, t7, t8, t9].filter(_temp4);
    t10 = <GridLayout sections={sections} />;
    $[24] = t5;
    $[25] = t6;
    $[26] = t7;
    $[27] = t8;
    $[28] = t9;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  return t10;
};
export default BusinessVault;
function _temp(bo) {
  return bo.ownershipStake != null;
}
function _temp2(attr) {
  return attr.identifier.startsWith("custom");
}
function _temp3($) {
  return $.bos.title;
}
function _temp4(section) {
  return Boolean(section);
}